import gql from "graphql-tag";
import { taskView } from "../fragments/task";
import { thread } from "../fragments/thread";

export const createTaskView = gql`
  mutation CreateTaskViewMutation($input: CreateTaskViewInput!) {
    taskView: createTaskView(input: $input) {
      ...TaskView
      workspace {
        id
        taskViews {
          ...TaskView
        }
      }
      user {
        id
        taskViews {
          ...TaskView
        }
      }
      organization {
        id
        taskViews {
          ...TaskView
        }
      }
      workspaceSection {
        id
        taskViews {
          ...TaskView
        }
      }
    }
  }

  ${taskView}
`;

export const updateTaskView = gql`
  mutation UpdateTaskViewMutation($input: UpdateTaskViewInput!) {
    taskView: updateTaskView(input: $input) {
      ...TaskView
      workspace {
        id
        taskViews {
          ...TaskView
        }
      }
      user {
        id
        taskViews {
          ...TaskView
        }
      }
      organization {
        id
        taskViews {
          ...TaskView
        }
      }
      workspaceSection {
        id
        taskViews {
          ...TaskView
        }
      }
    }
  }

  ${taskView}
`;

export const updateTaskThread = gql`
  mutation UpdateTaskThreadMutation($input: UpdateTaskInput!) {
    task: updateTask(input: $input) {
      id
      thread {
        ...Thread
      }
    }
  }

  ${thread}
`;
